import { AppPagination } from "@/components/commons/app-pagination"
import { AppSkeletonTable } from "@/components/commons/app-skeleton-table"
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import {
  useReceivableInstallments,
  useScheduleSearchParams,
} from "@/hooks"

import { ScheduleDownload } from "./download"
import { ScheduleTableRow } from "./table-row"

export const ScheduleInstallmentsTable = () => {
  const { params } = useScheduleSearchParams()
  const { data, isFetching } =
    useReceivableInstallments(params)

  const installments = data?.installments || []
  const hasInstallments = installments.length > 0
  const count = data?.count || 0

  const paginationData = {
    currentPage: params.page,
    total: count,
    totalPages: Math.ceil(count / params.quantity),
  }

  if (isFetching) return <AppSkeletonTable columns={9} />

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">
          Parcelas do período
        </h3>
        <ScheduleDownload />
      </div>

      {hasInstallments ? (
        <>
          <div className="relative overflow-x-hidden rounded-md border border-border">
            <Table className="relative h-10 w-full overflow-clip rounded-md border-border">
              <TableHeader className="sticky top-0 z-20 h-10 w-full bg-background outline outline-1 outline-border">
                <TableRow>
                  <TableHead className="w-[140px]">
                    Pedido
                  </TableHead>
                  <TableHead className="hidden w-[120px] lg:table-cell">
                    Data da venda
                  </TableHead>
                  <TableHead className="hidden w-[100px] text-center lg:table-cell">
                    Nº Parcela
                  </TableHead>
                  <TableHead className="hidden w-[120px] text-end lg:table-cell">
                    Valor
                  </TableHead>
                  <TableHead className="hidden w-[120px] text-end lg:table-cell">
                    Taxa
                  </TableHead>
                  <TableHead className="hidden w-[120px] text-end lg:table-cell">
                    Cashback
                  </TableHead>
                  <TableHead className="hidden w-[120px] text-end lg:table-cell">
                    Líquido
                  </TableHead>
                  <TableHead className="hidden w-[120px] text-center lg:table-cell">
                    Status
                  </TableHead>
                  <TableHead className="w-[60px] text-center"></TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {installments.map((installment) => (
                  <ScheduleTableRow
                    key={installment.transactionId}
                    installment={installment}
                  />
                ))}
              </TableBody>
            </Table>
          </div>
          <AppPagination pagination={paginationData} />
        </>
      ) : (
        <div className="flex flex-col items-center justify-center gap-2 rounded-md border border-dashed p-8 text-center text-muted-foreground">
          <p className="text-sm">
            Nenhuma parcela encontrada para o período
            selecionado
          </p>
        </div>
      )}
    </div>
  )
}
